<template>
  <section class="file-list">
    <div class="container">
      <h2
        class="font-55 f-light fade-up"
        v-if="_.get(contentData, 'conf.header.title')"
        v-in-viewport.once
      >
        {{ _.get(contentData, "conf.header.title") }}
      </h2>

      <div class="grid" :class="animation ? 'grid-anim' : ''">
        <template
          v-for="(item, index) in _.orderBy(
            _.get(contentData, 'data.list'),
            'sort',
            'asc'
          )"
        >
          <div
            @click="downloadItem(_.get(item, 'files[0]'))"
            class="pdf-file pointer fade-up"
            v-in-viewport.once
            :key="index"
          >
            <div class="main-content">
              <p class="font-16 title">{{ item.title }}</p>
              <div class="img-box">
                <picture>
                  <source
                    class="img-absolute scale"
                    media="(max-width: 767px)"
                    :srcset="_.get(item, 'images[0].devices.mobile')"
                  />
                  <source
                    class="img-absolute scale"
                    media="(max-width: 1023px)"
                    :srcset="_.get(item, 'images[0].devices.tablet')"
                  />
                  <img
                    class="img-absolute scale"
                    :src="_.get(item, 'images[0].devices.desktop')"
                    :alt="_.get(item, 'images[0].title.title')"
                  />
                </picture>
              </div>
            </div>
            <div class="download-button">
              <IconComponent name="download-arrow" class="download" />
              <p class="font-16">{{ $fn.tr("Download") }}</p>
            </div>
          </div>
        </template>
      </div>
      <center>
        <el-pagination
          class="pagination"
          background
          layout="prev, pager, next"
          :page-size.sync="page_size"
          :current-page.sync="current_page"
          :total="total"
          :disabled="false"
          :hide-on-single-page="true"
          @current-change="sendData"
          :key="'pagination'"
        >
        </el-pagination>
      </center>
    </div>
  </section>
</template>
<script>
import IconComponent from "../IconComponent.vue";
import fn from "../../helpers/func";

export default {
  props: ["contentData"],

  components: {
    IconComponent
  },
  data() {
    return {
      current_page: 1,
      animation: false
    };
  },
  computed: {
    page_size() {
      let tmp = _.get(this.contentData, "conf.page_count");
      return parseInt(tmp);
    },
    total() {
      return _.get(this.contentData, "data.listCount");
    }
  },
  methods: {
    downloadItem(val) {
      window.open(_.get(val, "url"), "_blank");
    },
    async sendData(val) {
      this.animation = true;
      window.scrollTo({ top: 0, behavior: "smooth" });
      let params;
      params = {
        componentUnicId: _.get(this.contentData, "conf.unicId"),
        id: _.get(this.$store.state.main.selected_menu, "id"),
        pageNumber: val
      };
      let res = await fn.postData("main/getDataList", params);

      if (_.get(res, "data")) {
        setTimeout(() => {
          this.animation = false;
          this.$set(this.contentData?.data, "list", res?.data?.list);
        }, 500);

        return true;
      }
    }
  }
};
</script>

<style lang="scss">
.file-list {
  padding: 55px 0 144px;
  background: var(--thirdy-tranparent);
  @media (max-width: 1365px) {
    padding: 55px 0 89px 0;
  }
  h2 {
    margin-bottom: 55px;
    color: var(--bonus-txt);
    word-break: break-word;
    @media (max-width: 1365px) {
      font-size: 34px;
    }
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    row-gap: 144px;
    column-gap: 30px;
    &.grid-anim {
      opacity: 0;
    }
    @media (max-width: 1365px) {
      row-gap: 20px;
      column-gap: 15px;
    }
    @media (max-width: 1200px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @media (max-width: 900px) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
    .pdf-file {
      width: 225px;
      padding: 30px;
      overflow: hidden;
      background: var(--white-bg);
      border: 1px solid var(--white-txt);
      @media (max-width: 1199px) {
        width: 100%;
      }
      .main-content {
        position: relative;
        padding-left: 19px;
        &::before {
          content: "";
          background: #dfdfdf;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          width: 2px;
          border-radius: 3px;
        }
        &::after {
          content: "";
          background: var(--red);
          max-height: 0;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          width: 2px;
          border-radius: 3px;
          transition: 0.4s ease-in-out;
        }
      }
      .img-box {
        position: relative;
        height: 174.79px;
        @media (max-width: 1199px) {
          height: unset;
          padding-bottom: 130%;
        }
        @media (max-width: 900px) {
          height: auto;
        }
        .img-absolute {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          object-fit: cover;
          // @media (max-width: 900px) {
          //   position: relative;
          // }
        }
      }
      p {
        color: var(--bonus-txt);
        margin-bottom: 24px;
      }
      .download-button {
        display: flex;
        align-items: center;
        margin-top: 10px;
        .download-arrow {
          margin: 0 10px 0 -6px;
        }
        p {
          margin: 0;
          color: var(--bonus-txt);
          text-decoration: underline;
          text-decoration-color: var(--bonus-txt);
        }
      }
      &:hover {
        @media (min-width: 1024px) {
          .main-content {
            &::after {
              max-height: 300px;
              height: 100%;
              transition: 0.4s ease-in-out;
            }
          }
          .download-button {
            .download-arrow {
              path {
                fill: var(--red);
              }
            }
            p {
              color: var(--red);
              text-decoration-color: var(--red);
            }
          }
        }
      }
    }
  }
}
</style>
